module.exports = __webpack_public_path__ + "img/2025-12-20g_5.1d5fe0ec.jpg";